export default "__VITE_ASSET__BvLV3f4j__"